<template>
  <button :class="bem({ view: props.view, active: option.active })" @click="emits('selected', props.option)">
    <div :class="bem('content-wrapper')">
      <div :class="bem('title-wrapper')">
        <span :class="bem('title')">
          {{ props.option.title }}
        </span>
        <div
          v-if="calculatedPrice"
          :class="bem('price')"
        >
          {{ calculatedPrice }}
        </div>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="props.view === 'full'"
        :class="bem('subtitle')"
        v-html="props.option.description"
      />
    </div>
    <!-- eslint-enable vue/no-v-html -->
  </button>
</template>

<script setup lang="ts">
interface Props {
  option: object
  view: 'compact' | 'full'
  customisedProduct: any
}

const props = withDefaults(defineProps<Props>(), {
  option: () => ({}),
  view: 'compact',
})

const { $tcs } = useNuxtApp()
const bem = useBEM('FrameTypeOption')
const emits = defineEmits([ 'selected' ])

const calculatedPrice = computed(() => {
  return $tcs(props.option.price)
})
</script>

<style lang="postcss" scoped>
.FrameTypeOption {
  @apply p-[18px] text-left
    relative
  bg-white
    border border-grey-400
    rounded-lg;
}

.FrameTypeOption__tag {
  @apply absolute top-0 -translate-y-1/2;
}

.FrameTypeOption__content-wrapper {
  @apply w-full;
}

.FrameTypeOption__title-wrapper {
  @apply flex justify-between mb-2;
}

.FrameTypeOption__title {
  @apply block font-bold text-xxs text-center lg:text-sm;
}

.FrameTypeOption__subtitle {
  @apply text-black text-[11px] md:text-xxs;
}

.FrameTypeOption__price {
  @apply flex justify-center items-center gap-1 flex-col text-grey-500 font-semibold text-xxs;
}

/**
  Modifiers
*/
.FrameTypeOption--active {
  @apply border-black;
}

.FrameTypeOption--view-full {
  @apply flex items-center gap-4;

  .FrameTypeOption__title {
    @apply text-left;
  }
}

.FrameTypeOption--view-compact {
  @apply p-4;

  .FrameTypeOption__title-wrapper {
    @apply flex-col mb-0;
  }
}
</style>
